<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_LEASE_TRANSFER_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm()" novalidate>
                    <div class="row">              
                        <section class="col-sm-6 lb" style="text-align: right;">{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_NAME' | translate }}</section>
                        <section class="col-sm-6 lb" style="text-align: left;">{{ customerName }}</section>
                        <section class="col-sm-6 lb" style="text-align: right;">{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_LEASE_NUMBER' | translate }}</section>
                        <section class="col-sm-6 lb" style="text-align: left;">{{ leaseTransferViewModel.leaseNumber }}</section>
                        <section class="col-sm-6 lb" style="text-align: right;">{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_NAME' | translate }}</section>
                        <section class="col-sm-6 lb" style="text-align: left;">{{ leaseTransferViewModel.dealerName }}</section>
                        <section class="col-sm-6 lb" style="text-align: right;">{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_ADDRESS' | translate }}</section>
                        <section class="col-sm-6 lb" style="text-align: left;">{{ leaseTransferViewModel.dealerAddress }}</section>
                        <section class="col-sm-6 lb" style="text-align: right;">{{ 'REQUEST_LEASE_TRANSFER_CONFIRM_DEALER_PHONE' | translate }}</section>
                        <section class="col-sm-6 lb" style="text-align: left;">{{ leaseTransferViewModel.dealerPhone }}</section>                       
                    </div>  
                    <p></p>  
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
                <p> </p>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>